<template>
  <section class="cn-product-characteristics">
    <div class="container">
      <h2 class="cn-product-characteristics__title">
        {{ $t('characteristics') }}
      </h2>
      <div
        v-if="data && data.items?.length"
        class="cn-product-characteristics__list"
      >
        <div
          v-for="(item, i) in data.items"
          :key="i"
          class="cn-product-characteristics__char"
        >
          <div class="cn-product-characteristics__char-left">
            <h3 class="cn-product-characteristics__char-title">
              {{ item.name }}
            </h3>
          </div>
          <div class="cn-product-characteristics__char-right">
            <ul class="cn-product-characteristics__char-list">
              <li
                v-for="(param, j) in item.features"
                :key="j"
                class="cn-product-characteristics__char-item"
              >
                <span class="cn-product-characteristics__char-item-name">
                  {{ param.name }}
                </span>
                <span
                  class="cn-product-characteristics__char-item-data"
                  v-html="param.value"
                />
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script setup lang="ts">
// TODO: fix type
interface Props {
  data: { items: any[] };
}
defineProps<Props>();
</script>

<style lang="scss">
.cn-product-characteristics {
  --ab-canyon-product-characteristics-title-color-text: var(
    --ab-canyon-color-dark
  );
  --ab-canyon-product-characteristics-char-title-color-text: var(
    --ab-canyon-color-primary
  );
  --ab-canyon-product-characteristics-char-item-color-border: var(
    --ab-canyon-color-neutral-light
  );
  --ab-canyon-product-characteristics-char-item-color-text: var(
    --ab-canyon-color-neutral-dark
  );

  padding-top: var(--size-3xl);
  padding-bottom: var(--size-3xl);
  &__title {
    color: var(--ab-canyon-product-characteristics-title-color-text);
    font-size: 1.5rem;
    line-height: 2rem;
    font-weight: 700;
    text-transform: uppercase;
  }
  &__list {
    margin-top: var(--size-lg);
    @media (min-width: 992px) {
      margin-top: var(--size-4xl);
    }

    > :not([hidden]) {
      ~ :not([hidden]) {
        margin-top: var(--size-4xl);
      }
    }
  }
  &__char {
    row-gap: var(--size-base);
    column-gap: var(--size-5xl);
    justify-content: space-between;
    flex-direction: column;
    display: flex;
    @media (min-width: 992px) {
      flex-direction: row;
    }
  }
  &__char-left {
    min-width: 250px;
  }
  &__char-title {
    color: var(--ab-canyon-product-characteristics-char-title-color-text);
    text-transform: uppercase;
    font-size: 1.25rem;
    line-height: 1.75rem;
  }
  &__char-right {
    max-width: calc(48 * var(--size-base));
    width: 100%;
  }
  &__char-item {
    border-color: var(
      --ab-canyon-product-characteristics-char-item-color-border
    );
    color: var(--ab-canyon-product-characteristics-char-item-color-text);
    font-size: 0.875rem;
    line-height: 1.25rem;
    padding-top: calc(var(--size-base) / 2);
    padding-bottom: calc(var(--size-base) / 2);
    border-bottom-width: 1px;
    column-gap: var(--size-base);
    display: flex;
  }
  &__char-item-name {
    width: 41.666667%;
  }
  &__char-item-data {
    text-align: right;
    width: 58.333333%;
    @media (min-width: 992px) {
      text-align: left;
    }
  }
}
</style>
